// File: LicenseStatus.jsx

import React from 'react';
import styles from './UserProfile.module.css';

const LicenseStatus = ({ plan, status, onManageBilling }) => {
  return (
    <div className={styles.userDetails}>
      <h2>Subscription Plan</h2>
      <p><strong>Current Plan:</strong> {plan}</p>
      <p><strong>Status:</strong> {status}</p>
      <button className={styles.editProfileButton} onClick={onManageBilling}>
        Manage Billing
      </button>
    </div>
  );
};

export default LicenseStatus;
